import BaseCrudService from "./baseCrud.service";

/**
 * Entrada do usuário logado na campanha do subdomínio (AUC-129): alimenta o sorteio por
 * participação na plataforma de leads. O back registra no máximo 1x por dia.
 */
export default class CampaignAccessService extends BaseCrudService {

    constructor() {
        super('CampaignAccess');
    }

    /** Sem mensagem nem loader: roda em segundo plano ao abrir a campanha. */
    register() {
        return this.postRequest('Register', {}, false, false);
    }

}
